import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";
import type { EkomiReviewsDto } from "@src/api-new/generated-api.schemas";

interface StaticPagesState {
  termsAndConditions: string;
  ekomiReviews: EkomiReviewsDto[];
}

const initialState: StaticPagesState = {
  ekomiReviews: [],
  termsAndConditions: ""
};

const staticPagesSlice = createSlice({
  name: "staticPages",
  initialState,
  reducers: {
    getTermsAndConditionsSuccess(state, action: PayloadAction<string>) {
      state.termsAndConditions = action.payload;
    },
    fetchEkomiReviewsRequest(state) {
      return state;
    },
    fetchEkomiReviewsSuccess(state, action: PayloadAction<EkomiReviewsDto[]>) {
      state.ekomiReviews = action.payload;
    },
    destroy() {
      return initialState;
    }
  }
});

export default staticPagesSlice.reducer;
export const {
  getTermsAndConditionsSuccess,
  fetchEkomiReviewsRequest,
  fetchEkomiReviewsSuccess,
  destroy
} = staticPagesSlice.actions;
export const staticPagesActions = staticPagesSlice.actions;
